const UpgradesConfig = [
  // {
  //   id: 1,
  //   displayName: 'DIFY',
  //   logoSrc: '',
  //   subHeading: '',
  //   heading: 'Affordable merch designs',
  //   body: 'Quickly set your store up for success with professionally-designed merch.',
  //   ctaText: 'Learn more ->',
  //   ctaLink: 'https://affinityx.creator-spring.com/',
  //   target: '_self',
  //   footnote: '',
  //   appIcon:
  //     'https://teespring-ass.s3.amazonaws.com/upgrades/designondemand.png',
  //   appDescription:
  //     'Quickly set your store up for success with professionally-designed merch.',
  //   appType: '',
  //   colSpan: 12,
  //   styles: {
  //     theme: 'light',
  //     align: 'left',
  //     jc: 'center',
  //     bgDesktop:
  //       'url("https://teespring-ass.s3.amazonaws.com/upgrades/DT_UPGRADES_983x400DIFY(1).png") center/cover',
  //     bgMobile:
  //       'url("https://teespring-ass.s3.amazonaws.com/upgrades/MOB_UPGRADES_327x280DIFY(1).png") center/cover',
  //     customStyles:
  //       'h3 {color: black}; p {color: black}; img:first-child {height: 40px}'
  //   }
  // },
  // {
  //   id: 1,
  //   displayName: 'Social Media Integrations',
  //   logoSrc: '',
  //   subHeading: '',
  //   heading: 'Boost merch sales',
  //   body: 'Sell your merch directly on your most popular social channels.',
  //   ctaText: 'Connect now ->',
  //   ctaLink: '/integrations/all',
  //   target: '_self',
  //   footnote: '',
  //   appIcon:
  //     'https://teespring-ass.s3.amazonaws.com/upgrades/DT_UPGRADES_ICON_1x.png',
  //   appDescription: 'Connect your products to your social accounts',
  //   appType: 'Integrate social media accounts',
  //   colSpan: 12,
  //   styles: {
  //     theme: 'light',
  //     align: 'left',
  //     jc: 'center',
  //     bgDesktop:
  //       'url(https://teespring-ass.s3.amazonaws.com/upgrades/DT_UPGRADES_983x400_1x.png) center/cover',
  //     bgMobile:
  //       'url(https://teespring-ass.s3.amazonaws.com/upgrades/MOB_UPGRADES_327x280_1x.png) center/cover',
  //     customStyles:
  //       'h3 {color: black}; p {color: black}; img:first-child {height: 40px}'
  //   }
  // },
  // {
  //   id: 1,
  //   isSpecialBanner: false,
  //   elementName: 'ignite_manged_2024',
  //   displayName: 'Ignite Program',
  //   logoSrc: '',
  //   subHeading: '',
  //   heading: 'Ready to level up?',
  //   body: 'See if you qualify to unlock custom stores, special drops, and marketing campaigns—Plus a dedicated growth manager, all free!',
  //   ctaText: 'Take the quiz',
  //   ctaLink: 'https://share.hsforms.com/1Kxlj5mOSRMigaF9SL7HpYAe19c5',
  //   target: '_blank',
  //   footnote: '',
  //   appIcon:
  //     'https://teespring-ass.s3.amazonaws.com/upgrades/dt_upgrades_icon.png',
  //   appDescription:
  //     "Apply now and see if you're qualified to unlock special perks!",
  //   appType: 'Managed creator program tool',
  //   colSpan: 12,
  //   styles: {
  //     theme: 'dark',
  //     align: 'left',
  //     jc: 'center',
  //     txtColor: '#000000',
  //     bgDesktop:
  //       'url(https://teespring-ass.s3.amazonaws.com/upgrades/ignite_manged_2024_dt_upgrades_983x400.png) center/cover',
  //     bgMobile:
  //       'url(https://teespring-ass.s3.amazonaws.com/upgrades/ignite_manged_2024_mob_upgrades_327x280.png) center/cover'
  //   }
  // },
  {
    id: 1,
    isSpecialBanner: false,
    elementName: 'rent_studio_space',
    displayName: 'Rent studio space',
    logoSrc: '',
    subHeading: '',
    heading: 'SoCal creators:  Need a pro studio?',
    body: 'Book professional space for filming, podcasts, livestreams, and more.',
    ctaText: 'Book a Tour',
    ctaLink: 'https://www.amaze.co/loft-100',
    target: '_blank',
    footnote: '',
    appIcon:
      'https://teespring-ass.s3.us-east-1.amazonaws.com/upgrades/rent_studio_space_icon.png',
    appDescription: 'Book a tour today',
    appType: 'Rent studio space',
    colSpan: 12,
    styles: {
      theme: 'dark',
      align: 'left',
      jc: 'center',
      txtColor: '#ffffff',
      backgroundColor: '#063075',
      bgDesktop:
        '#063075 no-repeat url(https://teespring-ass.s3.us-east-1.amazonaws.com/upgrades/rent_studio_space.png) calc(100% - 40px) center/290px auto',
      bgMobile:
        '#063075 no-repeat url(https://teespring-ass.s3.amazonaws.com/upgrades/rent_studio_space_mob.png) center/contain'
    }
  },
  {
    id: 4,
    isSpecialBanner: true,
    elementName: 'alphabeats',
    displayName: 'Alphabeats',
    logoSrc: '',
    subHeading: '',
    heading: '',
    body: '',
    ctaText: '',
    ctaLink: 'https://www.listenalphabeats.com/partners/amaze',
    target: '_blank',
    footnote: '',
    appIcon:
      'https://teespring-ass.s3.amazonaws.com/upgrades/alphabeats_logo.png',
    appDescription: 'Targeted mental performance training for creators',
    appType: 'mental performance technology',
    colSpan: 12,
    styles: {
      theme: 'light',
      align: 'left',
      jc: 'center',
      bgDesktop:
        '#192b20 no-repeat url(https://teespring-ass.s3.amazonaws.com/upgrades/alphabeats_desktop.png) center/contain',
      bgMobile:
        '#192b20 no-repeat url(https://teespring-ass.s3.amazonaws.com/upgrades/alphabeats_mobile.jpg) center/contain',
      txtColor: '#000000',
      customStyles: ''
    }
  },
  // {
  //   id: 4,
  //   displayName: 'Mamenta',
  //   logoSrc: '',
  //   subHeading: '',
  //   heading: '',
  //   body: '',
  //   ctaText: '',
  //   ctaLink: 'https://www.mamenta.com/what-is-mamenta-watch-now',
  //   target: '_blank',
  //   footnote: '',
  //   appIcon: 'https://teespring-ass.s3.amazonaws.com/upgrades/mamenta_icon.png',
  //   appDescription: 'Your brand, everywhere.',
  //   appType: 'Connect tools',
  //   colSpan: 12,
  //   styles: {
  //     theme: 'light',
  //     align: 'left',
  //     jc: 'center',
  //     bgDesktop:
  //       '#030305 no-repeat url(https://teespring-ass.s3.amazonaws.com/upgrades/mamenta_desktop_980x400.jpg) center/contain',
  //     bgMobile:
  //       '#0e1837 no-repeat url(https://teespring-ass.s3.amazonaws.com/upgrades/mamenta_mobile_327x280.jpg) center/contain',
  //     txtColor: '#000000',
  //     customStyles: ''
  //   }
  // },
  // {
  //   id: 5,
  //   isSpecialBanner: false,
  //   elementName: 'amaze',
  //   displayName: 'Amaze',
  //   logoSrc: 'https://teespring-ass.s3.amazonaws.com/upgrades/amaze-logo.png',
  //   subHeading: '',
  //   heading:
  //     'Amaze <span style="font-style:italic; font-weight: 400;margin-left: -7px;">with</span> Spring',
  //   body: "Boost sales of your Spring products using Amaze's<br> beautiful no-code product pages.",
  //   ctaText: 'Create now',
  //   ctaLink:
  //     'https://amaze.spri.ng/?utm_source=upgrades_page&utm_medium=affiliate&utm_campaign=amaze+x+spring',
  //   target: '_blank',
  //   footnote: '',
  //   appIcon:
  //     'https://teespring-ass.s3.amazonaws.com/upgrades/amaze-icon-new.png',
  //   appDescription: 'Create beautiful no-code product pages',
  //   appType: 'Selling tools',
  //   colSpan: 12,
  //   styles: {
  //     theme: 'dark',
  //     align: 'left',
  //     jc: 'center',
  //     bgDesktop:
  //       'url(https://teespring-ass.s3.amazonaws.com/upgrades/amaze-banner-bg.png) center/cover',
  //     bgMobile:
  //       'url(https://teespring-ass.s3.amazonaws.com/upgrades/amaze-banner-bg-mobile.png) center/cover',
  //     customStyles:
  //       'h3 {background: linear-gradient(146.62deg, #59A4F0 14.03%, #3755F0 86.36%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;background-clip: text;text-fill-color: transparent;}'
  //   }
  // }
  {
    id: 6,
    isSpecialBanner: false,
    elementName: 'studio-by-amaze',
    displayName: 'Studio by Amaze',
    logoSrc: '',
    subHeading: '',
    heading: 'Drag. Drop. Launch.',
    body: 'Use Studio by Amaze to build custom, on-brand pages and connect them to your store in minutes—no code needed.',
    ctaText: 'Learn More',
    ctaLink: 'https://www.amaze.co/studio',
    target: '_blank',
    footnote: '',
    appIcon:
      'https://teespring-ass.s3.us-east-1.amazonaws.com/upgrades/upgrade-amaze-icon.png',
    appDescription: 'Start creating your custom pages.',
    appType: 'Studio by Amaze',
    colSpan: 12,
    styles: {
      theme: 'dark',
      align: 'left',
      jc: 'center',
      txtColor: '#ffffff',
      bgDesktop:
        '#1954EB no-repeat url(https://teespring-ass.s3.us-east-1.amazonaws.com/upgrades/dt_upgrade_dt.png) right/contain',
      bgMobile:
        '#1954EB no-repeat url(https://teespring-ass.s3.us-east-1.amazonaws.com/upgrades/dt_upgrade_mob.png) right/contain'
    }
  }
];

export default UpgradesConfig;
